import { createSlice } from '@reduxjs/toolkit'
import { getTemplates, saveTemplate, createTemplate, deleteTemplate } from './templateActions'

const initialState = {
  templates: [],
  loading: false,
  loadingError: false,
  loaded: false,
  saving: false,
  savingError: false,
  saved: false,
  savedTemplate: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loadingError = false
      state.loaded = false

      state.saving = false
      state.savingError = false
      state.saved = false
      state.savedTemplate = {}

      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getTemplates.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.loadingError = null
        state.templates = payload
      })
      .addCase(getTemplates.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.loadingError = null
      })
      .addCase(getTemplates.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.loadingError = payload
      })
      .addCase(saveTemplate.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveTemplate.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.templates[state.templates.findIndex((p) => p.id === payload.id)] = payload
        state.savedTemplate = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveTemplate.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createTemplate.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createTemplate.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedTemplate = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createTemplate.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteTemplate.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteTemplate.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteTemplate.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
  },
})

export const { clear } = templatesSlice.actions
export default templatesSlice.reducer
